import { type EventEmitter, type FunctionalComponent, h } from '@stencil/core';

export interface MyProductsBarEventLayer {
	onEnterEventEmitter: (e) => void;
	eventBuilder: (e) => void;
}

export interface ProductEventGa {
  groupId?: string;
  infoForGa?: GaData;
  productsFailed?: Array<string>;
  productsUpdated?: Array<string>;
  status?: string;
  tmpCart?: string;
}

export interface ProductGa {
  brand: string;
  currency: string;
  description: string;
  price: string;
}

export interface GaData {
  [key: string]: ProductGa;
}

export const clickedElement = (e) =>
  [
    ...(e.composedPath()?.filter((el) => el?.dataset?.myProductsArea) ?? []),
  ]?.[0]?.dataset?.myProductsArea;

export const getCartValue = (infoForGa: GaData, productArr: Array<string>) => {
    let currency = '';
    let totalPrice = 0;
    for (const product of productArr) {
      if (infoForGa[product]?.currency) {
        currency = infoForGa[product].currency;
      }
      if (infoForGa[product]?.price) {
        totalPrice += Number(infoForGa[product].price) || 0;
      }
    }
    return { currency, totalPrice };
};

export const getProductItems = (
  infoForGa: GaData,
  productArr: Array<string>,
  groupId: string,
) => {
    const items = [];
    for (const product of productArr) {
      items.push({
        item_id: product,
        item_name: infoForGa[product].description,
        item_brand: infoForGa[product].brand,
        item_list_name: 'Search Result Page',
        item_list_id: groupId,
        item_category: 'Product',
        item_category2: '',
        item_category3: '',
        item_variant: '',
        price: infoForGa[product].price,
        quantity: 1,
      });
    }
    return items;
};

export const MyProductsBarEventLayer: FunctionalComponent<
  MyProductsBarEventLayer
> = (props, children) => {
    const { onEnterEventEmitter, eventBuilder } = props;

    return (
      <host
        onMouseDown={(e) => eventBuilder(e)}
        onKeyDown={(e) => onEnterEventEmitter(e)}
      >
        {children}
      </host>
    );
};
